import React from 'react';
import ReactDOM from 'react-dom';

export default class ModalPortal extends React.Component {
	node = document.getElementById('modal-global-container');

	render(): React.ReactPortal {
		return ReactDOM.createPortal(
			this.props.children,
			this.node as HTMLElement
		);
	}
}